import React from "react";
import styled from "styled-components";
import curseArrow from '../../assets/icons/curse-arrow.svg';
import AngleDoublePrev from "../../assets/icons/angle-double-prev.svg";
import AngleDoubleNext from "../../assets/icons/angle-double-next.svg";
import {Alert} from "react-bootstrap";


export const SchedulesContainer = styled.div`
  .content-list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
  }
  .react-multi-carousel-list{
    padding: 5px;
  }
  .tableColumn {
    text-align: center;
  }
  .nav-item.date-container {
    background-color: #f1f1f1;
  }
  .nav-item.date-container a {
    padding 10px 0;
  }
  .nav-item.date-container a.active {
    background-color: #fff;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
  }
  .nav-item.date-container a .dateWrapper {
    pointer-events: none;
  }
  .btn-info {
    color: #9cc54b;
    font-size: 14px;
    background-color: #fff;
    border: 1px solid #9cc54b;
    width: 90%;
    margin-bottom: 5px;
    margin-top: 5px;
    padding: 5px 0;
  }

  .btn-info:hover,  .btn-info.active{
    color: #fff !important;
    background-color: #9cc54b !important;
    border: 1px solid #9cc54b !important;
    box-shadow: none !important;
  }

  .dateWrapper {
    text-align: center;
    color: #9cc54b;
  }
  .active .dateWrapper {
    color: rgb(255, 173, 94);
  }
  .dateWrapper .day {
    text-transform: uppercase;
    font-size: 22px;
    font-weight: 900;
    line-height: 1;
  }
  .disabledButton{
    background-color: #979696;
    border: 1px solid #979696;
    color: #000;
    font-size: 14px;
    height: auto;
    font-weight: 400;
    pointer-events: none;
  }

  .prevButton, .nextButton{
    border: none;
    background: none;
    padding: 0;
  }
  .prevButton:before {
    content: '';
    display: block;
    background-image: url(${AngleDoublePrev});
    width: 26px;
    height: 26px;
  }
  .nextButton:hover, .prevButton:hover{
    opacity: 0.8;
  }
  .nextButton:before {
    content: '';
    display: block;
    background-image: url(${AngleDoubleNext});
    width: 26px;
    height: 26px;
  }
`;

export const ButtonGroupwrapper = styled.div`
  position: absolute;
  margin-top: -50px;
  width: 100%;
  margin-left: -20px;
  display: flex;
  justify-content: space-between;
  pointer-events: none;

  button {
  pointer-events: auto;
  }
`;


// Styled Components (re-used and slightly modified for custom navigation)
export const PageContainer = styled.div`
    padding: 1rem;
    font-family: 'Inter', sans-serif;
`;

export const LoadingContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 1rem 0;
`;

export const StyledAlert = styled(Alert)`
    text-align: center;
    margin: 1rem 0;
`;

export const DateNavWrapper = styled.div`
    position: relative;
    margin-bottom: 1.5rem;
    display: flex;
    align-items: center;
    justify-content: space-between; /* Ensures arrows are at ends */
    background-color: #f8f9fa; /* Light background for the nav bar */
    //border-radius: 0.75rem;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    //padding: 0.5rem;
`;

export const DateNavScrollContainer = styled.div`
    display: flex;
    overflow-x: auto; /* Enable horizontal scrolling */
    -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
    scrollbar-width: none; /* Hide scrollbar for Firefox */
    -ms-overflow-style: none; /* Hide scrollbar for Internet Explorer and Edge */
    flex-grow: 1;
    padding: 0; /* Padding inside scroll container */
    background-color: #eceaea;

    &::-webkit-scrollbar {
        display: none; /* Hide scrollbar for Chrome, Safari, Opera */
    }
`;

export const StyledNavLinkButton = styled.div`
    padding: 0.75rem 0.5rem; /* Adjusted padding */
    text-align: center;
    font-weight: bold;
    border-bottom: 2px solid transparent;
    transition: all 0.2s ease-in-out;
    outline: none;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-width: 90px; /* Adjusted min-width for each date button */
    flex-shrink: 0; /* Prevent shrinking */
    background: none;
    border-top: none;
    border-left: none;
    border-right: none;
    cursor: pointer;
    //border-radius: 0.5rem; /* Rounded corners for date buttons */
    //margin: 0 0.25rem; /* Small margin between date buttons */

    &.active {
        border-color: #9cc54b;
        color: #ffffff;
        background-color: #9cc54b; /* Light green background for active date */
    }

    &:not(.active) {
        color: #9cc54b;

        &:hover {
            border-color: #9cc54b;
            color: #ffffff;
            background-color: #9cc54b; /* Slight hover background */
        }
    }

    .small {
        font-size: 0.875em;
        line-height: 1.2;
    }
`;

export const NavArrowButton = styled.div`
    background-color: #ffffff; /* White background for arrows */
    border-radius: 50%;
    padding: 8px;
    z-index: 10;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin: 0 5px; /* Add some margin */
    transition: background-color 0.2s ease-in-out;

    &:hover:not(:disabled) {
        background-color: #e9ecef;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
        box-shadow: none;
    }
`;

export const SlotsGridRow = styled.div`
    display: flex;
    flex-wrap: wrap;
    margin-right: -1.5rem;
    margin-left: -1.5rem;
`;

export const SlotColumn = styled.div`
    flex: 0 0 100%;
    max-width: 100%;
    padding-right: 0.50rem;
    padding-left: 0.50rem;
    margin-bottom: 1rem;

    @media (min-width: 768px) {
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
    }
`;

export const SlotsInnerContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(1, 1fr); /* Creates 3 equal columns */
    gap: 5px; /* Space between columns */
    height: 100%; /* Ensure the row takes full height of its parent */
`;

export const NoSlotsMessage = styled.div`
    color: #6c757d;
    text-align: center;
    padding: 1rem;
    border: 1px solid #dee2e6;
    border-radius: 0.25rem;
    background-color: #f8f9fa;
`;

